import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

export const LoadingState: React.FC = () => {
	return <Spinner className="mx-auto my-6" />;
};
